import {
  Dropdown,
  DropdownItem,
  IconMoon,
  IconSun,
} from '@swaggerhub-portal/component-library'
import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'

import { MODE } from '../DarkMode/constants'
import { useDarkMode } from '../DarkMode/hook'
import darkMode from '~/images/modes/dark-mode.svg'
import lightMode from '~/images/modes/light-mode.svg'
import systemMode from '~/images/modes/system-mode.svg'

export const DarkModeToggleLoggedOut = ({ accentColor = '' }) => {

  const { t } = useTranslation()

  const { setMode, isDark } = useDarkMode()

  const ModeItem = ({ image, text, className = '' }) => (
    <span className={clsx('flex pt-[6px] w-52 items-center', className)}>
      <img src={image} alt={text} />
      <span className="ml-4">{text}</span>
    </span>
  )

  const modeToggleItems: DropdownItem[] = [{
    name: MODE.LIGHT,
    content: <ModeItem image={lightMode} text={t('components.ui.modeToggle.light')} />,
  }, {
    name: MODE.DARK,
    content: <ModeItem image={darkMode} text={t('components.ui.modeToggle.dark')} />,
  },
  {
    name: MODE.SYSTEM,
    content: <ModeItem image={systemMode} text={t('components.ui.modeToggle.system')} className="pb-[6px]" />,
  }
  ]

  const toggleDarkMode = (mode: string) => setMode(mode as MODE)

  return (
    <Dropdown
      menuItems={modeToggleItems}
      onClick={toggleDarkMode}
      dropdownButton={<span className="flex items-center py-3 dark:text-neutral-20 text-neutral-98">
        {isDark() ? <IconMoon /> : <IconSun />}
        <span className="ml-1">{t('components.ui.modeToggle.label')}</span>
      </span>}
      accentColor={accentColor}
      ariaLabel={t('consumer.ui.modeToggle.ariaLabel')}
      className="h-10 px-4 w-28 min-w-28"
    />
  )
}